export interface AppConfig {
  api: {
    baseUrl: string;
    timeout: number;
    retries: number;
  };
  pagination: {
    defaultPageSize: number;
    maxPageSize: number;
    pageSizeOptions: number[];
  };
  auth: {
    tokenExpiryWarning: number;
    sessionTimeout: number;
    refreshTokenThreshold: number;
  };
  ui: {
    defaultLanguage: string;
    supportedLanguages: string[];
    theme: 'light' | 'dark' | 'auto';
    animations: boolean;
  };
  logging: {
    level: 'debug' | 'info' | 'warn' | 'error';
    enableConsole: boolean;
    enableRemote: boolean;
  };
}

export const APP_CONFIG: AppConfig = {
  api: {
    baseUrl: 'http://localhost:3000/api',
    timeout: 30000,
    retries: 3
  },
  pagination: {
    defaultPageSize: 20,
    maxPageSize: 100,
    pageSizeOptions: [10, 20, 50, 100]
  },
  auth: {
    tokenExpiryWarning: 5 * 60 * 1000, // 5 minutos
    sessionTimeout: 30 * 60 * 1000, // 30 minutos
    refreshTokenThreshold: 10 * 60 * 1000 // 10 minutos
  },
  ui: {
    defaultLanguage: 'es',
    supportedLanguages: ['es', 'en'],
    theme: 'light',
    animations: true
  },
  logging: {
    level: 'error',
    enableConsole: false,
    enableRemote: false
  }
};

export const APP_CONSTANTS = {
  STORAGE_KEYS: {
    AUTH_TOKEN: 'auth_token',
    REFRESH_TOKEN: 'refresh_token',
    USER_PREFERENCES: 'user_preferences',
    THEME: 'app_theme',
    LANGUAGE: 'app_language'
  },
  HTTP_STATUS: {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503
  },
  EVENTS: {
    AUTH_LOGIN: 'auth:login',
    AUTH_LOGOUT: 'auth:logout',
    AUTH_TOKEN_EXPIRED: 'auth:token_expired',
    USER_PROFILE_UPDATED: 'user:profile_updated',
    THEME_CHANGED: 'ui:theme_changed',
    LANGUAGE_CHANGED: 'ui:language_changed'
  }
};

export const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  PHONE: /^\+?[\d\s\-()]{10,}$/,
  URL: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/
};

export const ERROR_MESSAGES = {
  NETWORK: {
    CONNECTION_ERROR: 'Error de conexión. Verifica tu conexión a internet.',
    TIMEOUT: 'La solicitud ha tardado demasiado. Inténtalo de nuevo.',
    SERVER_ERROR: 'Error del servidor. Inténtalo más tarde.',
    UNAUTHORIZED: 'No tienes autorización para acceder a este recurso.',
    FORBIDDEN: 'Acceso denegado.',
    NOT_FOUND: 'El recurso solicitado no fue encontrado.'
  },
  VALIDATION: {
    REQUIRED: 'Este campo es obligatorio.',
    EMAIL_INVALID: 'Ingresa un email válido.',
    PASSWORD_WEAK:
      'La contraseña debe tener al menos 8 caracteres, incluyendo mayúsculas, minúsculas, números y símbolos.',
    MIN_LENGTH: 'Debe tener al menos {0} caracteres.',
    MAX_LENGTH: 'No puede tener más de {0} caracteres.'
  },
  AUTH: {
    INVALID_CREDENTIALS: 'Usuario o contraseña incorrectos.',
    SESSION_EXPIRED: 'Tu sesión ha expirado. Inicia sesión nuevamente.',
    ACCOUNT_LOCKED: 'Tu cuenta ha sido bloqueada. Contacta al administrador.'
  }
};
